import { render, staticRenderFns } from "./InvoiceProcess.vue?vue&type=template&id=3228fc3b&scoped=true"
import script from "./InvoiceProcess.vue?vue&type=script&lang=js"
export * from "./InvoiceProcess.vue?vue&type=script&lang=js"
import style0 from "./InvoiceProcess.vue?vue&type=style&index=0&id=3228fc3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228fc3b",
  null
  
)

export default component.exports